module.exports = __webpack_public_path__ + "files/7404ccde50aa0b71777e7664a497100f.png";